var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-view"),
      _vm._v(" "),
      _c("c-alert"),
      _vm._v(" "),
      _c("c-confirm"),
      _vm._v(" "),
      _c("c-loading"),
      _vm._v(" "),
      _c("c-toast"),
      _vm._v(" "),
      _c("vue-snotify")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }